import React, { useEffect, useState, useCallback } from "react";
import { Modal, Typography, Form, message, Select } from "antd";
import styled from "styled-components";
import VeritasSpinner from '../VeritasSpinner'

export const Label = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  
  &:nth-child(1) {
    margin-left: auto;
  }
`

const ReassignModal = ({
  apiClasses,
  caseId,
  visible,
  setVisible,
  onSuccess,
}) => {
  const [loading, setLoading] = useState(false);
  const [availableProviders, setAvailableProviders] = useState([])

  const getEligiblePhysicians = useCallback(async () => {
    if (!apiClasses?.PhysicianAPI) {
      message.error("PhysicianAPI is not available");
      return;
    }
    
    try {
      setLoading(true)
      const response = await apiClasses.PhysicianAPI.getEligiblePhysiciansForReassignment([caseId])
      setAvailableProviders(response.data.physicians)
    } catch (e) {
      console.error("Error fetching eligible physicians:", e)
      message.error("Unable to get eligible physicians");
    } finally {
      setLoading(false)
    }
  }, [apiClasses, caseId])

  useEffect(() => {
    if (visible && caseId) {
      getEligiblePhysicians()
    }
  }, [visible, caseId, getEligiblePhysicians])

  const assignToPhysician = async (providerId) => {
    if (!apiClasses?.CasesApi) {
      message.error("CasesAPI is not available");
      return;
    }
    
    try {
      setLoading(true)
      await apiClasses.CasesApi.bulkReassign({ caseIds: [caseId], physicianId: providerId })
      onSuccess()
    } catch (e) {
      const errorMessage = e.response?.data?.message || e.message
      console.error("Error reassigning case:", e)
      message.error("Unable to reassign case", errorMessage);
    } finally {
      setLoading(false)
    }
  };

  return (
    <Modal
      title="Reassign"
      open={visible}
      closable={!loading}
      onCancel={() => setVisible(false)}
      destroyOnClose
      zIndex={1010}
      footer={null}
    >
      <VeritasSpinner spinning={loading}>
        <Form>
          <Label>
            <Typography.Text>Assign to</Typography.Text>
          </Label>
          <Form.Item name="assignTo">
            <Select
              id="reassign-provider-select"
              showSearch
              filterOption={(input, option) =>
                (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
              }
              options={availableProviders
                .filter(provider => provider.lastName && provider.firstName)
                .map(provider => ({ 
                  label: `${provider.lastName}, ${provider.firstName}`, 
                  value: provider._id }))
                }
              onSelect={assignToPhysician}
            />
          </Form.Item>
        </Form>
      </VeritasSpinner>
    </Modal>
  )
}

export default ReassignModal
